export default {
  GET_CHANNEL:(state,payload)=>{
    state.channels = payload
  },
  DELETE_CHANNEL: (state, payload) => {
    let i = state.channels.findIndex(u => u.id === payload)
    state.channels.splice(i, 1)
  }
}
